import { __awaiter } from 'tslib';
import 'long';
import { im_proto } from '../proto/index.js';
import { ErrorType, IMEvent } from '../core/consts.js';
import { Logger } from '../core/metrics/logger.js';
import { BaseError } from '../core/errors/BaseError.js';
import '../core/metrics/monitor.js';
import '../core/network/NetworkItem.js';
import { ServiceIdentity } from '../core/service/RuntimeContext.js';
import 'json-long';
import 'moize';
import { Message } from '../core/model/Message.js';
import 'js-md5';
import '../core/utils/lz4.js';
import '../core/utils/serializer.js';
import '../adapter/manager/AdapterManager.js';
import '../adapter/manager/types.js';
import '../core/utils/ticker.js';
import '../adapter/abstract/IMNetApi.js';
import '../core/options.js';
import '../core/utils/uuid.js';
import '../core/service/ConversationManager.js';
import '../core/service/MessageManager.js';
import '@byted/uc-secure-sdk';
import '../core/plugin/DbProxy.js';
import '../core/metrics/trackerTypes.js';
import { BasePlugin } from '../core/plugin/BasePlugin.js';
import '../core/model/CommandMessage.js';
import { RtcApiManager } from './api/RtcApiManager.js';
import { RtcCommandMessage } from './model/RtcMessage.js';
import { RtcController } from './RtcController.js';
import { RtcManager } from './RtcManager.js';

class RtcPluginCore extends BasePlugin {
    constructor(ctx) {
        super(ctx);
        this.initAdapter();
    }
    /**
    *  rtc功能将移除
    *  @private
    */
    checkRtcRequirements() {
        return this.resolve(ServiceIdentity.RtcManager).checkSystemRequirements();
    }
    /**
    *  创建rtc中心 rtc功能将移除
    *  @private
    */
    createRtcController(params) {
        return __awaiter(this, void 0, void 0, function* () {
            if (!this.checkRtcRequirements()) {
                throw new BaseError({
                    ctx: this.ctx,
                    type: ErrorType.RtcNotSupported,
                    sender: this,
                    msg: 'rtc not supported in current environment/browser'
                });
            }
            const useCurrent = this.resolve(ServiceIdentity.RtcController)
                && RtcController.genIdeomptentId(params.target) === RtcController.genIdeomptentId(this.resolve(ServiceIdentity.RtcController).target);
            if (!useCurrent) {
                if (this.resolve(ServiceIdentity.RtcController) !== undefined) {
                    yield this.resolve(ServiceIdentity.RtcController).reset();
                }
                const controller = new RtcController(this.ctx, this.api, params.target);
                yield controller.init();
                this.register(ServiceIdentity.RtcController, controller);
            }
            else {
                Logger.ctxDebug(this.ctx, `use cached controller: ${RtcController.genIdeomptentId(params.target)}`);
            }
            return this.resolve(ServiceIdentity.RtcController);
        });
    }
    dispose() {
        return __awaiter(this, void 0, void 0, function* () {
            // 释放rtc资源
            if (!this.checkRtcRequirements()) {
                return;
            }
            yield this.resolve(ServiceIdentity.RtcManager).reset(this.api);
        });
    }
    receivePacket(packet) {
        var _a;
        return __awaiter(this, void 0, void 0, function* () {
            if (packet.cmd === im_proto.IMCMD.NEW_MSG_NOTIFY) {
                const body = packet.body.has_new_message_notify;
                const m = Message.fromServerMessage(this.ctx, body.message);
                if (m.type === im_proto.MessageType.MESSAGE_TYPE_VOIP_COMMAND) {
                    if (!this.checkRtcRequirements()) { // 不支持rtc的情况, 不上抛事件
                        return;
                    }
                    const rtcCommand = m;
                    RtcCommandMessage.fillRtcParam(rtcCommand);
                    // 特殊情况, 自己创建controller并拨出, 这种时候收到的cmd会不一样
                    // 但是 callerId 一定是自己, 所以就是自己刚才创建的 controller
                    // 还需要处理下 busy 的情况, 这种时候不能创建 controller, 直接进处理逻辑回一个 occupied
                    if (rtcCommand.callerId !== this.ctx.option.userId && !this.resolve(ServiceIdentity.RtcManager).isBusy) {
                        yield this.createRtcController({
                            target: rtcCommand.callerId
                        });
                    }
                    yield this.resolve(ServiceIdentity.RtcManager).handleRtcCmdMessage(rtcCommand);
                    // 在ringing则上抛
                    if (((_a = this.resolve(ServiceIdentity.RtcManager).info) === null || _a === void 0 ? void 0 : _a.voipStatus) === im_proto.VoipStatus.RINGING) {
                        this.resolve(ServiceIdentity.EventBus).emit(IMEvent.ReceiveRtc, this, this.resolve(ServiceIdentity.RtcController));
                    }
                }
                else if (m.type === im_proto.MessageType.MESSAGE_TYPE_VOIP_CALLEE_LIST_UPDATE_NOTIFY) {
                    Logger.ctxDebug(this.ctx, 'unknown 80004:', m);
                }
            }
        });
    }
    install() {
        var _a;
        this.api = this.register(ServiceIdentity.RtcApi, RtcApiManager);
        this.register(ServiceIdentity.RtcManager, RtcManager);
        this.register(ServiceIdentity.RtcPlugin, this);
        this.ctx.option.rtcAppId = (_a = this.ctx.option.rtcAppId) !== null && _a !== void 0 ? _a : '61b87410714959009c47bada';
        this.instance.checkRtcRequirements = this.extendFunc(this.checkRtcRequirements);
        this.instance.createRtcController = this.extendFunc(this.createRtcController);
    }
    initAdapter() {
        // impl by sub class
    }
}

export { RtcPluginCore };
//# sourceMappingURL=RtcPlugin.js.map
